import {globalMessageHandler, Rules, transformOptions, ValidationErrors, Validator} from "common";
import {useEffect, useState} from "react";
import {invite, InviteForm, inviteOptions, InviteOptions, inviteService} from "./inviteAPI";
import I18n from "i18n-js";

export interface InviteFormProps {
  defaultValues?: InviteForm;
  onModalClose: Function | undefined;
}

export function validateInvite(values: InviteForm) {
  const rules: Rules = {
    email: Validator.rule.string().required(),
    role: Validator.rule.string().required(),
  };
  return Validator.validate(rules, values, "InviteForm");
}

export default function useInviteForm({defaultValues, onModalClose}: InviteFormProps) {
  const [item, setItem] = useState<InviteForm>(
    defaultValues || ({} as InviteForm)
  );
  const [errors, setErrors] = useState<ValidationErrors>({});
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState<InviteOptions>({} as InviteOptions);

  useEffect(() => {
    inviteOptions().then((response) => {
      setOptions(
        transformOptions(response['data'].data.invite.baseFields)
      );
    })
  }, []);

  function onClose() {
    setItem({} as InviteForm);
    onModalClose && onModalClose();
  }

  function onChange(values: InviteForm) {
    if (values.permissions) {
      let newPermission: string[] = values.permissions;
      const allOptions = options.permissions;
      values.permissions.forEach((value: string, index: number) => {
        const match = value.match(/^(manage|view)(.+)$/);
        if (match && match[1] && match[2]) {
          const [type, permission] = [match[1], match[2]];
          if (type == "manage") {
            const otherPermissionValue = "view" + permission;

            let otherTypeFound = false;
            allOptions.forEach((option) => {
              if (option.value == otherPermissionValue) {
                otherTypeFound = true;
              }
            });

            if (otherTypeFound && !values.permissions.includes(otherPermissionValue)) {
              newPermission.push(otherPermissionValue);
            }
          }
        }
      });

      values.permissions = newPermission;
    }

    setItem(values);
  }

  async function process() {
    setLoading(true);
    const result = validateInvite(item);
    setErrors(result.errors);

    if (!result.success) {
      setLoading(false);
      return;
    }

    const response = await invite(item);
    setLoading(false);

    if (response.success) {
      globalMessageHandler.success(I18n.t("InviteForm.success"));
      onClose();
    } else {
      setErrors(response.error.form_errors);
    }
  }

  return {
    item,
    options,
    errors,
    process,
    onChange,
    onClose,
    loading,
  };
}